// Which site's reserve link stands for the whole facility on the request
// form's "View map" button. The booking strategies build the preview from
// one site, and a facility's first site in sort order can be the odd one
// out: Yukon's Tombstone Mountain lists group site 1 first, so an RV request
// used to open the provider's Group tab with a party of four. Prefer a site
// the form's current site type matches (the request filter's own rule: rv
// and tent include rv_tent), then the facility's most common type, then the
// first site.
function typeMatches(siteType, type) {
  if (!siteType || !type) return false;
  return siteType === "rv" || siteType === "tent"
    ? type.includes(siteType)
    : type === siteType;
}

export function choosePreviewSite(sites, siteType = null) {
  const list = Array.isArray(sites) ? sites.filter(Boolean) : [];
  if (list.length === 0) return null;
  const ofType = list.find((site) => typeMatches(siteType, site.type));
  if (ofType) return ofType;
  const counts = new Map();
  for (const site of list) {
    if (!site.type) continue;
    counts.set(site.type, (counts.get(site.type) ?? 0) + 1);
  }
  let majority = null;
  for (const [type, count] of counts) {
    if (majority === null || count > majority.count) majority = { type, count };
  }
  return majority ? list.find((site) => site.type === majority.type) : list[0];
}
